import axios from '@/axios'

const state = {
    invoicingBatchTypes: [],
    invoicingClientPrinciples: [],
    invoicingView: [],
    invoicingBatchStatuses: []
};

const getters = {
    getInvoicingBatchTypes: (state) => state.invoicingBatchTypes,
    getInvoicingClientPrinciples: (state) => state.invoicingClientPrinciples,
    getInvoicingView: (state) => state.invoicingView,
    getInvoicingBatchStatuses: (state) => (state).invoicingBatchStatuses
};

const actions = {
    async loadBatchTypesAndPrincipalsForInvoicing(context) {
        await axios().get(`/getBatchTypesAndPrincipalsForInvoicing`)
            .then(response => {
                context.commit('setInvoicingBatchTypes', response.data.invoicingBatchTypes)
                context.commit('setInvoicingClientPrinciples', response.data.invoicingClientPrinciples)
                context.commit('seInvoicingBatchStatuses', response.data.invoicingBatchStatuses)
            })
    },
    async loadInvoicingView(context, data) {
        await axios().get(`/getInvoicingView`, {
            params: {
                batch_reference: data.batch_reference,
                invoice_number: data.invoice_number,
                date_from: data.date_from,
                date_to: data.date_to,
                batch_type: data.batch_type,
                principles: data.principles,
                page: data.page,
                per_page: data.per_page,
                status: data.status
            }
        }).then(response => {
            if (response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            }
            context.commit('setInvoicingView', response.data.invoicingView)
        })
    },
    async deleteInvoicingBatch(context, data) {
        await axios().post(`/deleteInvoicingBatch`, {
            itemId: data.itemId
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async updateInvoicingBatch(context, data) {
        await axios().post(`/updateInvoicingBatch`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
};

const mutations = {
    setInvoicingBatchTypes: (state, invoicingBatchTypes) => (state.invoicingBatchTypes = invoicingBatchTypes),
    setInvoicingClientPrinciples: (state, invoicingClientPrinciples) => (state.invoicingClientPrinciples = invoicingClientPrinciples),
    setInvoicingView: (state, invoicingView) => (state.invoicingView = invoicingView),
    seInvoicingBatchStatuses: (state, invoicingBatchStatuses) => (state.invoicingBatchStatuses = invoicingBatchStatuses),
};

export default {
    state,
    getters,
    actions,
    mutations
}
